<template>
	<div class="tabsGroup">
		<tabs :tab-width="mode == 'full' ? 170 : 150" :views="rounds" :active-view="activeRound" v-on:change="activeRound = $event" :key="'tab-views'" :height="mobile ? 60 : 40" />
		<tabs v-if="activeRound.code == 'round2' && runoffs.list.length > 1" :level="'secondary'" :tab-width="mobile ? 95 : 130" :views="runoffs" :active-view="activeRunoff" v-on:change="activeRunoff = $event" :key="'tab-viewsRunoffs'" :enable-slider="true" :height="50" />
	</div>
</template>
<script>
	import Tabs from 'global/components/Tabs'
	export default {
		name: 'TabsGroup',
		components: { Tabs },
		props: {
			rounds: {
				type: Object,
				required: true,
			},
			runoffs: {
				type: Object,
				required: true,
			},
			mobile: {
				type: Boolean,
				default: false,
			},
			mode: {
				type: String,
				default: 'full',
			},
		},
		data: function() {
			return {
				activeRound: null,
				activeRunoff: null,
			}
		},
		created() {
			this.activeRound = this.rounds.list.find(r => r.code == this.rounds.default)
			this.activeRunoff = this.runoffs.list.find(r => r.code == this.runoffs.default)
		},
		watch: {
			activeRound: function(round) {
				this.$emit('change', { type: 'round', value: round.code })
			},
			activeRunoff: function(runoff) {
				this.$emit('change', { type: 'runoff', value: runoff.code })
			},
		}
	}
</script>
<style lang="scss">
	.main--light {
		.tabsWrapper:first-child {
			margin-bottom: 2em;
		}
	}
	.tabsGroup {
		margin-bottom: 2em;
	}
	@media screen and (max-width: 600px) {
		.tabs {			
			&Wrapper + .tabsWrapper {
				margin-top: -30px;
			}
		}
	}
</style>